module.exports = __webpack_public_path__ + "f333aae36375c1404bcbf51d38710479.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Bold-Oblique.eot
// module id = 407
// module chunks = 0